import {
  AbsolutePositionAligner,
  MenuItem,
  useDocumentEvent,
} from '@sgcmpteltd/uikit-react';
import {
  DOCUMENT_EVENT_NAME_CLICK,
} from '@sgcmpteltd/uikit-react/hooks/use-document-event';
import {
  alignBottomXEnd,
} from '@sgcmpteltd/uikit-react/utils/position/absolute';
import cx from 'clsx';
import { useEffect, useRef, useState } from 'react';

import { ImageWithFallback } from '@/components/image-with-fallback';
import { joinSgcmMedia } from '@/utils/url/join/public';

import styles from './styles.module.scss';
import type { Component } from './types';

export const PricelistMenu: Component = ({
  pricelistType,
  menuName,
  optionList,
  onItemClick,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [hasApplied, setHasApplied] = useState(false);
  const buttonRootElRef = useRef<HTMLDivElement>(null);
  const menuRootElRef = useRef<HTMLDivElement>(null);
  const onDocMouseClickRef = useRef<Document['onclick'] | null>(null);

  const handleButtonClick = () => {
    if (isDropdownOpen) {
      setIsDropdownOpen(false);
      return;
    }
    setIsDropdownOpen(true);
  };

  const handleItemClick = (value?: string | number | undefined) => {
    onItemClick(value);
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    if (hasApplied) {
      setIsDropdownOpen(false);
      setHasApplied(false);
    }
  }, [hasApplied]);

  onDocMouseClickRef.current = ({ target }) => {
    if (
      (target instanceof Node
      && (buttonRootElRef.current?.contains(target)
      || menuRootElRef.current?.contains(target)
      ))
    ) {
      return;
    }
    setIsDropdownOpen(false);
  };
  useDocumentEvent({
    eventName: DOCUMENT_EVENT_NAME_CLICK,
    eventHandlerRef: onDocMouseClickRef,
  });
  const targetElement = (
    <div
      ref={menuRootElRef}>
      <div className={cx(
        styles.containerMenuList,
        pricelistType === 'ad' ? styles.isAdPricelist : styles.isPiPricelist,
      )}>
        {optionList.map(option => (
          <MenuItem
            key={option.value}
            contentClassName={cx(
              styles.textMenuContent,
              styles.isMediumText,
            )}
            value={option.value}
            onClick={handleItemClick}>
            {option.text}
          </MenuItem>
        ))}
      </div>
    </div>
  );

  return (
    <AbsolutePositionAligner
      isActive={isDropdownOpen}
      rectCalculator={alignBottomXEnd}
      targetElement={targetElement}>
      <div
        ref={buttonRootElRef}
        className={styles.containerPricelistDatesMenu}
        role="button"
        tabIndex={0}
        onClick={handleButtonClick}
        onKeyDown={handleButtonClick}>
        <div className={`${cx(styles.containerHead, isDropdownOpen && styles.isDropdownOpen, pricelistType === 'pi' && styles.isPiPricelist)}`}>
          <div className={styles.textButton}>
            <ImageWithFallback
              alt=""
              className={styles.imageDownload}
              height={16}
              src={`${joinSgcmMedia('/public/new-cars/icon/downloadIcon.svg')}`}
              width={18} />
            <span className={styles.textSelectName}>
              {menuName}
            </span>
          </div>
        </div>
      </div>
    </AbsolutePositionAligner>
  );
};
